import { request } from './appBridge';
import { lang } from '../lang/index';

// 申请注销
function applyLogout(reason) {
  return request({
    type: 'post',
    method: 'safety/apply',
    data: {
      reason
    },
    resolveData: false
  });
}

// 验证邮箱
function verifyEmail(data) {
  return request({
    type: 'post',
    method: 'safety/check',
    data: {
      scene: 3,
      ...data
    },
    resolveData: false
  });
}
// 验证邮箱
function verifyPhone(data) {
  return request({
    type: 'post',
    method: 'safety/check',
    data: {
      scene: 2,
      ...data
    },
    resolveData: false
  });
}

// 验证注销条件
function checkLogout(applyId) {
  return request({
    type: 'post',
    method: 'safety/check',
    data: {
      applyId,
      scene: 1
    },
    resolveData: false
  });
}

// 常见问题
function helpCommon(limit = 10) {
  // if (mock) {
  //   return new Promise((resolve, reject) => {
  //     let data = require('../../cli/mockdata/help_common.json');
  //     resolve(data.data);
  //   });
  // }
  return request({
    type: 'get',
    method: 'help/common',
    data: {
      limit
    },
    directRequest: true
  });
}

// 常见问题分类
function helpCategory() {
  // if (mock) {
  //   return new Promise((resolve, reject) => {
  //     let data = require('../../cli/mockdata/help_category.json');
  //     resolve(data.data);
  //   });
  // }
  return request({
    type: 'get',
    method: 'help/category',
    directRequest: true
  });
}

// 问题列表
function helpList(data) {
  // if (mock) {
  //   return new Promise((resolve, reject) => {
  //     let data = require('../../cli/mockdata/help_list.json');
  //     resolve(data.data);
  //   });
  // }
  return request({
    type: 'get',
    method: 'help/list',
    data,
    directRequest: true
  });
}

// 问题反馈
function helpFeedback(data) {
  return request({
    type: 'get',
    method: 'help/common',
    data
  });
}

// 满意度调查
function helpQuest(data) {
  return request({
    type: 'post',
    method: 'help/questionnaire',
    data
  });
}

// 提交反馈
function feedbackSubmit(data) {
  // console.log('feedbackSubmit', data);
  return request({
    type: 'post',
    method: 'v4/feedback/submit',
    data
  });
}

// 提交反馈
function feedbackSend(data) {
  return request({
    type: 'post',
    method: 'v4/feedback/send',
    data
  });
}

// 是否有用
function evaluateHelp(data) {
  return request({
    type: 'post',
    method: 'help/feedback',
    data
  });
}

// 产品列表https://www.showdoc.cc/8109?page_id=4149165888095408
function getProduct(data) {
  return request({
    type: 'get',
    method: 'v4/coupon/product',
    data
  });
}

// 申诉详情  {appeal_id}
function getAppealDetail(data) {
  return request({
    type: 'get',
    method: 'v4/coupon/appeal-detail',
    data
  });
}

// https://www.showdoc.cc/8109?page_id=4149091937538701
function postCouponAppeal(data) {
  return request({
    type: 'post',
    method: 'v4/coupon/appeal',
    data,
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 反馈聊天信息
function feedbackMessage(data) {
  // if (mock) {
  //   return new Promise((resolve, reject) => {
  //     let data = require('../../cli/mockdata/v4_feedback_message.json');
  //     console.log(data);
  //     resolve(data.data);
  //   });
  // }

  return request({
    type: 'get',
    method: 'v4/feedback/message',
    data
  });
}

// 反馈历史消息
function feedbackHistory(data) {
  // if (mock) {
  //   return new Promise((resolve, reject) => {
  //     let data = require('../../cli/mockdata/v4_feedback_history.json');
  //     resolve(data.data);
  //   });
  // }
  return request({
    type: 'get',
    method: 'v4/feedback/history',
    data
  });
}

function helpDetail(data) {
  return request({
    type: 'get',
    method: 'help/detail',
    data,
    directRequest: true
  });
}

function shareInvite(data) {
  return request({
    type: 'get',
    method: 'share/invite/history?lang=' + lang,
    data
  });
}

// https://www.showdoc.com.cn/8109?page_id=15678003 获取商城数据
function getShoppingProduct(data) {
  // return new Promise((resolve, reject) => {
  //   let data = require('../../cli/mockdata/v1_site_product.json');
  //   resolve(data.data);
  // });
  return request({
    type: 'get',
    method: 'v1/site/product?lang=' + lang,
    data
  });
}

function getRanking(type) {
  return request({
    type: 'get',
    method: `word/ranking/${type}?lang=${lang}`
  });
}

function getStickerCollection(type) {
  // return Promise.resolve(
  //   require('../../cli/mockdata/sticker_collection.json').data
  // );
  return request({
    type: 'get',
    method: `sticker/collection?lang=${lang}`
  });
}

function subscribeSticker(data) {
  return request({
    type: 'post',
    method: `sticker/subscribe?lang=${lang}`,
    data,
    resolveData: false
  });
}

function getStickerDetail(id) {
  // return Promise.resolve(
  //   require('../../cli/mockdata/sticker_detail.json').data
  // );
  return request({
    type: 'get',
    method: `sticker/collection/detail?lang=${lang}&stickerCollectionId=${id}`
  });
}

export {
  applyLogout,
  checkLogout,
  verifyEmail,
  verifyPhone,
  helpCommon,
  request,
  helpList,
  helpFeedback,
  helpCategory,
  helpQuest,
  feedbackSubmit,
  feedbackSend,
  feedbackMessage,
  evaluateHelp,
  feedbackHistory,
  getProduct,
  getAppealDetail,
  postCouponAppeal,
  helpDetail,
  shareInvite,
  getShoppingProduct,
  getRanking,
  getStickerCollection,
  subscribeSticker,
  getStickerDetail
};
